/**
 PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA

 *  Copyright © 2020 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
* */

import React from 'react';
import PropTypes from 'prop-types';
import Qrcode from 'qrcode';

/**
 * A Component that renders QrCodes
 *
 * @author Anthony Ng
 */

function QrCode({ url, width }) {
  const canvasRef = React.useRef();

  React.useEffect(() => {
    Qrcode.toCanvas(canvasRef.current, url, {
      width
    });
  }, [url]);

  return (
    <canvas ref={canvasRef} />
  );
}

QrCode.propTypes = {
  url: PropTypes.string.isRequired,
  width: PropTypes.number
};

QrCode.defaultProps = {
  width: 500
};

export default QrCode;



// WEBPACK FOOTER //
// ./src/js/components/QrCode/QrCode.jsx